import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deliveriesMasterClient } from "apollo";
import { MasterListDeliveryActiveTrackingQuery } from "apollo/queries/masters";

const initialState = {
    dataList: [],
    loading: false,
}

export const listDeliveryTracking = createAsyncThunk('masters/deliveryTracking/list', async() => {
    const { data } = await deliveriesMasterClient.query({
        query: MasterListDeliveryActiveTrackingQuery,
        variables: {},
        fetchPolicy: 'network-only',
    })
    return data?.data ?? {}
})

const deliveryTrackingSlice = createSlice({
    name: 'masters/deliveryTracking',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    },
    extraReducers: {
        [listDeliveryTracking.pending]: (state) => {
            state.loading = true
        },
        [listDeliveryTracking.fulfilled]: (state, action) => {
            state.dataList = action.payload
            state.loading = false
        }
    }
})

export const {
    setLoading,
} = deliveryTrackingSlice.actions

export default deliveryTrackingSlice.reducer